module.exports = __webpack_public_path__ + "static/media/ai-code-generation.f01a1616.svg";